/*
===============================================================================
    File        =   ikimy-website-app/src/pages/Candidate/Candidate.js
    Client      =   Rhealize
    Project     =   Ikimy Platform
    Purpose     =   Landing page for the candidate
                    
===============================================================================
    Revision History
        -----------------------------------------------------------------------
        Version Date        Author              Comments
        -----------------------------------------------------------------------
        1.0     2025.02.12  Moataz khallaf      Initial Creation
        1.1     2025.02.27  Daniel Rashidian    Change query to check for width 
        1.2     2025.02.28  Daniel Rashidian    Changed layout
        -----------------------------------------------------------------------
===============================================================================
*/
// react
import { useMediaQuery } from 'react-responsive'
// components
import DesktopCandidate from "./DesktopCandidate";
import MobileCandidate from "./MobileCandidate";

// ui-components

const Candidate = () => {
    const isPortrait = useMediaQuery({ query: '(max-width: 768px)' })

    return (
        <>
            { isPortrait && <MobileCandidate /> }
            { !isPortrait && <DesktopCandidate /> }
        </>        
    )
};

export default Candidate;